import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import { TextField, SelectField, Loadable, If } from "components/support";

import _ from "lodash";

import { CNPJ, CPF } from "cpf_cnpj";

class CustomerFormGeneralInfo extends Component {
  static IdentificationTypes = [
    { label: "Selecione", value: "" },
    { label: "CPF", value: "cpf" },
    { label: "CNPJ", value: "cnpj" },
    { label: "Id. Estrangeira", value: "id" }
  ];

  static IdentificationMask = {
    cpf: {
      maskPattern: [
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/
      ]
    },
    cnpj: {
      maskPattern: [
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        "/",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/
      ]
    },
    id: {}
  };

  state = {
    identificationType: this.typeSelected()
  };

  typeSelected() {
    const { customer } = this.props;
    if (customer.identification === "") {
      return "";
    } else if (customer.identification.length === 11) {
      return CPF.isValid(customer.identification) ? "cpf" : "id";
    } else if (customer.identification === 14) {
      return CNPJ.isValid(customer.identification) ? "cnpj" : "id";
    } else {
      return "id";
    }
  }

  handleIdentificationTypeChange = value =>
    this.setState({ identificationType: value });

  handleIdentificationChange = value => {
    this.props.onChange("identification", "", value.replace(/\D/g, ""));

    if (this.state.identificationType === "cnpj") {
      this.props.presenter.onIdentificationChangeCnpj(value.replace(/\D/g, ""));
    }
  };

  optionChange(value) {
    const { errors } = this.props;
    errors.identification = "";
    this.setState({ identificationType: value });
  }

  render() {
    const { customer, errors, viewModel, onChange, fields } = this.props;
    const { loading } = viewModel;
    const { identificationType } = this.state;
    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <div className="grid-container mt-sm mb-sm">
                <Row>
                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "name" }) === -1
                    }
                  >
                    <Col xs={12} sm={6}>
                      <TextField
                        fullWidth
                        underlineShow={false}
                        value={customer.name}
                        floatingLabelFixed
                        floatingLabelText="Nome"
                        onChange={(_, value) => onChange("name", "", value)}
                        errorText={errors.name}
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "email" }) === -1
                    }
                  >
                    <Col xs={12} sm={6}>
                      <TextField
                        fullWidth
                        underlineShow={false}
                        value={customer.email}
                        floatingLabelFixed
                        floatingLabelText="E-mail"
                        onChange={(_, value) =>
                          onChange("email", "", !value.length ? null : value)
                        }
                        errorText={errors.email}
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, {
                        show: false,
                        key: "identification"
                      }) === -1
                    }
                  >
                    <Col xs={12} sm={4} lg={3}>
                      <SelectField
                        floatingLabelFixed
                        floatingLabelText="Tipo"
                        value={identificationType}
                        onChange={(_, value) => this.optionChange(value)}
                        underlineStyle={{ bottom: "0" }}
                        labelStyle={{ height: "44px" }}
                        fullWidth
                        options={CustomerFormGeneralInfo.IdentificationTypes}
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, {
                        show: false,
                        key: "identification"
                      }) === -1
                    }
                  >
                    <Col xs={12} sm={8} lg={3}>
                      <TextField
                        fullWidth
                        underlineShow={false}
                        floatingLabelText="Identificação"
                        value={customer.identification}
                        onChange={(_, value) =>
                          this.handleIdentificationChange(value)
                        }
                        errorText={errors.identification}
                        {...CustomerFormGeneralInfo.IdentificationMask[
                          identificationType
                        ]}
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "phone" }) === -1
                    }
                  >
                    <Col xs={12} lg={3}>
                      <TextField
                        maskPattern={[
                          "(",
                          /\d/,
                          /\d/,
                          ")",
                          " ",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/
                        ]}
                        fullWidth
                        underlineShow={false}
                        value={customer.phone}
                        floatingLabelFixed
                        floatingLabelText="Telefone"
                        onChange={(_, value) =>
                          onChange("phone", "", value.replace(/\D/g, ""))
                        }
                        errorText={errors.phone}
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, {
                        show: false,
                        key: "birth_date"
                      }) === -1
                    }
                  >
                    <Col xs={12} lg={3}>
                      <TextField
                        maskPattern={[
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/
                        ]}
                        fullWidth
                        underlineShow={false}
                        value={customer.birth_date}
                        floatingLabelFixed
                        floatingLabelText="Data de Nascimento"
                        onChange={(_, value) =>
                          onChange("birth_date", "", value)
                        }
                        errorText={errors.birth_date}
                      />
                    </Col>
                  </If>

                  <If
                    test={
                      _.findIndex(fields, { show: false, key: "notes" }) === -1
                    }
                  >
                    <Col xs={12}>
                      <TextField
                        rows={5}
                        fullWidth
                        multiLine
                        value={customer.notes}
                        floatingLabelFixed
                        floatingLabelText="Observações"
                        onChange={(_, value) => onChange("notes", "", value)}
                        errorText={errors.notes}
                        multilineMaxLength={1000}
                      />
                    </Col>
                  </If>
                </Row>
              </div>
            </Loadable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CustomerFormGeneralInfo;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/general-info/view.jsx